import React, { useEffect, useState } from "react";
import axios from 'axios';

// --- SVG Icon Components ---
// To fix the import error, the react-icons have been replaced with inline SVGs.
// This removes the external dependency and makes the component self-contained.

const CalendarCheckIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" fill="currentColor" width="1em" height="1em">
        <path d="M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm329.7 89.7c-9.4-9.4-24.6-9.4-33.9 0l-96 96-48-48c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L329.7 315.6c9.4-9.4 9.4-24.6 0-33.9z"/>
    </svg>
);

const MapMarkerAltIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" fill="currentColor" width="1em" height="1em">
        <path d="M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67a24 24 0 0 1-35.464 0zM192 272a80 80 0 1 0 0-160 80 80 0 1 0 0 160z"/>
    </svg>
);

const InfoCircleIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" width="1em" height="1em">
        <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336h24V272H216c-13.3 0-24-10.7-24-24s10.7-24 24-24h48c13.3 0 24 10.7 24 24v88h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H216c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-144a32 32 0 1 1 0-64 32 32 0 1 1 0 64z"/>
    </svg>
);

const NoEventsIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" style={{ color: '#bdc3c7', marginBottom: '1rem' }}>
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line><line x1="12" y1="15" x2="12" y2="15"></line><path d="M12 15l.01 0"></path>
    </svg>
);

const QRCodeIcon = ({ className }) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="currentColor" width="1em" height="1em">
        <path d="M0 0H192V192H0V0zM64 64V128H128V64H64zM320 0H512V192H320V0zM384 64V128H448V64H384zM0 320H192V512H0V320zM64 384V448H128V384H64zM448 320H512V384H480V512H416V448H384V384H448V320zM320 320H384V384H320V320zM320 384H352V512H288V448H320V384z"/>
    </svg>
);



// --- Individual Event Card Component ---
const BookedEventCard = ({ event, style }) => (
    <div className="booked-event-card" style={style}>
        <div className="card-header">
            <img 
                src={`https://ethiccraft.org/${event.banner_image1}`} 
                alt={`${event.event_name} Banner`} 
                className="event-banner"
                onError={(e) => { e.target.onerror = null; e.target.src='https://placehold.co/600x300/FFFBF5/4a4a4a?text=Event'; }}
            />
            <h3 className="event-title">{event.event_name}</h3>
        </div>
        <div className="card-body">
            <div className="event-detail">
                <CalendarCheckIcon className="icon" />
                <span><strong>Date:</strong> {event.event_date}</span>
            </div>
            <div className="event-detail">
                <MapMarkerAltIcon className="icon" />
                <span><strong>Venue:</strong> {event.venue}</span>
            </div>
            <div className="event-detail">
                <InfoCircleIcon className="icon" />
                <span><strong>Booking Time:</strong> {event.booking_time}</span>
            </div>
            {/* --- QR Code Image --- */}
            <div className="event-detail">
                <QRCodeIcon className="icon" />
                <span><strong>QR Code:</strong> </span>
            </div>
            {event.qr_code && (
                <div className="qr-code-container">
                    <img 
                        src={`${event.qr_code}`} 
                        alt="QR Code" 
                        className="qr-code-image"
                        onError={(e) => { e.target.style.display = 'none'; }}
                    />
                </div>
            )}
        </div>
    </div>
);

// --- Main EventBookings Component ---
const EventBookings = () => {
    const [bookedEvents, setBookedEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const BOOKINGS_API_URL = "https://ethiccraft.org/backend/event_bookings/read.php";
    const EVENTS_API_URL = "https://ethiccraft.org/backend/upcoming_events/read_isShown.php";

    // Helper function to get a cookie by name
    const getCookie = (name) => {
        const cookieString = document.cookie;
        const cookies = cookieString.split(';');
        for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i].trim();
            if (cookie.startsWith(name + '=')) {
                return cookie.substring(name.length + 1);
            }
        }
        return null;
    };

    useEffect(() => {
        const fetchBookedEvents = async () => {
            try {
                setLoading(true);
                setError(null);

                const userEmail = getCookie('email');
                if (!userEmail) {
                    setBookedEvents([]);
                    setLoading(false); // Stop loading if no user
                    return; 
                }

                const [eventsResponse, bookingsResponse] = await Promise.all([
                    axios.get(EVENTS_API_URL),
                    axios.get(BOOKINGS_API_URL, { withCredentials: true })
                ]);

                const allEvents = eventsResponse.data;
                const allBookings = bookingsResponse.data;

                if (!Array.isArray(allBookings) || !Array.isArray(allEvents)) {
                    setBookedEvents([]);
                    return;
                }
                
                const userBookings = allBookings.filter(booking => booking.email === userEmail);

                const eventsMap = allEvents.reduce((acc, event) => {
                    acc[event.id] = event;
                    return acc;
                }, {});

                const mergedData = userBookings
                    .map(booking => {
                        const eventDetails = eventsMap[booking.event_id];
                        if (eventDetails) {
                            return {
                                ...booking,
                                event_name: eventDetails.name,
                                event_date: eventDetails.date,
                                venue: eventDetails.venue,
                                banner_image1: eventDetails.banner_image1,
                                booking_time: booking.booking_time,
                                qr_code: booking.qr_code_url,
                            };
                        }
                        return null;
                    })
                    .filter(Boolean);
                setBookedEvents(mergedData);
                console.log(mergedData);
            } catch (err) {
                let errorMessage = "An unexpected error occurred.";
                if (err.response) {
                    errorMessage = `Failed to fetch events. Server responded with status: ${err.response.status}`;
                } else if (err.request) {
                    errorMessage = "Could not connect to the server. Please check your network connection.";
                } else {
                    errorMessage = err.message;
                }
                setError(errorMessage);
            } finally {
                setLoading(false);
            }
        };

        fetchBookedEvents();
    }, []);

    if (loading) {
        return (
            <div className="event-bookings-container status-container">
                <div className="premium-loader"></div>
                <p>Loading Your Bookings...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="event-bookings-container status-container">
                <div className="error-message">
                    <h3>Oops! Something Went Wrong</h3>
                    <p>{error}</p>
                    <button onClick={() => window.location.reload()} className="btn-retry">
                        Try Again
                    </button>
                </div>
            </div>
        );
    }

    return (
        <div className="event-bookings-container">
            <div className="heading-wrapper">
                <h2>
                    <span className="upcoming-title">My</span> <span className="fest-title">Bookings</span>
                </h2>
                <div className="header-underline"></div>
            </div>

            {bookedEvents.length === 0 ? (
                <div className="status-container empty-state">
                    <NoEventsIcon />
                    <p className="no-events-message">You haven't booked any events yet.</p>
                    <p>Your booked events will appear here once you register.</p>
                </div>
            ) : (
                <div className="events-grid">
                    {bookedEvents.map((event, index) => (
                        <BookedEventCard 
                            key={event.booking_id} 
                            event={event} 
                            style={{ animationDelay: `${index * 100}ms` }}
                        />
                    ))}
                </div>
            )}

            <style>{`
                :root {
                    --primary-color: #4a90e2;
                    --primary-glow: rgba(74, 144, 226, 0.4);
                    --background-color: #f7f8fc;
                    --card-background: #ffffff;
                    --text-color: #333;
                    --subtle-text: #777;
                    --border-color: #e8eaf0;
                }
                body {
                    background-color: var(--background-color);
                    font-family: 'Poppins', sans-serif; /* A more premium font */
                }
                .event-bookings-container {
                    padding: 2rem;
                    max-width: 1200px;
                    margin: 2rem auto;
                }
                .heading-wrapper {
                    text-align: center;
                    margin-bottom: 3rem;
                }
                .heading-wrapper h2 {
                    font-size: 2.8rem;
                    font-weight: 700;
                    margin-bottom: 0.5rem;
                }
                .upcoming-title { color: var(--text-color); }
                .fest-title { 
                    color: var(--primary-color);
                    background: -webkit-linear-gradient(45deg, #ff5900ff, #a0cfa2ff);
                    -webkit-background-clip: text;
                    -webkit-text-fill-color: transparent;
                }
                .header-underline {
                    width: 80px;
                    height: 5px;
                    background: linear-gradient(45deg, #ff5900ff, #81c784);
                    margin: 0.5rem auto 0 auto;
                    border-radius: 2.5px;
                }
                .status-container {
                    text-align: center;
                    padding: 4rem 1rem;
                    color: var(--subtle-text);
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                }

                /* Premium Loader */
                .premium-loader {
                    width: 50px;
                    height: 50px;
                    border-radius: 50%;
                    background: conic-gradient(#0000 10%, var(--primary-color));
                    -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);
                    animation: spin 1s infinite linear;
                    margin-bottom: 1rem;
                }
                
                .error-message {
                    background-color: #fff0f0;
                    border: 1px solid #ffcccc;
                    padding: 2rem;
                    border-radius: 12px;
                    color: #d8000c;
                    max-width: 500px;
                }
                .btn-retry {
                    background-image: linear-gradient(45deg, #5c6bc0, #42a5f5);
                    color: white;
                    border: none;
                    padding: 0.8rem 1.8rem;
                    border-radius: 50px;
                    cursor: pointer;
                    font-weight: 600;
                    margin-top: 1.5rem;
                    transition: all 0.3s ease;
                    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
                }
                .btn-retry:hover {
                    transform: translateY(-3px);
                    box-shadow: 0 7px 20px rgba(74, 144, 226, 0.3);
                }
                .empty-state {
                    background: var(--card-background);
                    border-radius: 16px;
                    padding: 3rem;
                    border: 1px dashed var(--border-color);
                }
                .no-events-message {
                    font-size: 1.3rem;
                    font-weight: 600;
                    color: var(--text-color);
                }
                .events-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
                    gap: 2rem;
                }
                .booked-event-card {
                    background: var(--card-background);
                    border-radius: 16px;
                    border: 1px solid var(--border-color);
                    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
                    overflow: hidden;
                    transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                    display: flex;
                    flex-direction: column;
                    opacity: 0;
                    transform: translateY(20px);
                    animation: cardFadeIn 0.5s ease-out forwards;
                }
                @keyframes cardFadeIn {
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                .booked-event-card:hover {
                    transform: translateY(-8px) scale(1.02);
                    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
                    border-color: var(--primary-color);
                }
                .card-header {
                    position: relative;
                }
                .event-banner {
                    width: 100%;
                    height: 180px;
                    object-fit: cover;
                    filter: brightness(0.95);
                }
                .event-title {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    background: linear-gradient(to top, rgba(0,0,0,0.85) 10%, rgba(0,0,0,0));
                    color: white;
                    padding: 2rem 1.5rem 1.5rem 1.5rem;
                    margin: 0;
                    font-size: 1.5rem;
                    font-weight: 600;
                }
                .card-body {
                    padding: 1.5rem;
                    flex-grow: 1;
                }
                .event-detail {
                    display: flex;
                    align-items: center;
                    gap: 1rem;
                    margin-bottom: 1rem;
                    color: var(--text-color);
                    font-size: 0.95rem;
                }
                .event-detail .icon {
                    color: var(--primary-color);
                    font-size: 1.2rem;
                    flex-shrink: 0;
                }
                .event-detail span {
                    line-height: 1.5;
                }
                .qr-code-container {
                    margin-top: 1.5rem;
                    text-align: center;
                }
                .qr-code-image {
                    width: 120px;
                    height: 120px;
                    object-fit: contain;
                    border: 1px solid #e0e0e0;
                    border-radius: 8px;
                    padding: 0.5rem;
                    background-color: #fafafa;
                }
                @keyframes spin {
                    to { transform: rotate(1turn); }
                }
            `}</style>
        </div>
    );
};

export default EventBookings;